var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "680",
      maxWidth: "680",
      title: _vm.$t("label_essweb_shift_form_dialog_viewPropertyLabel"),
      dialog: _vm.show,
    },
    on: { close: _vm.closePorpertyDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.RosterPropertyGroup,
                            "item-text": "roster_property_group_name",
                            "item-value": "uuid",
                            dense: "",
                            disabled: "",
                            placeholder: _vm.$t(
                              "label_essweb_RosterPropertyGroup_list_title"
                            ),
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value:
                              _vm.RosterFormMasterData
                                .roster_property_group_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.RosterFormMasterData,
                                "roster_property_group_uuid",
                                $$v
                              )
                            },
                            expression:
                              "RosterFormMasterData.roster_property_group_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "grey lighten-5 rounded-lg",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("PropertyList", {
                          attrs: {
                            items: _vm.desserts,
                            canView: false,
                            canEdit: false,
                            listdata: _vm.PropertyListData,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }